// Small helper for building Jira deep-links from issue keys. Centralised so
// every drill-down table reads from the same constant — if the Atlassian
// site name ever changes we touch one file. Kept as a module-level const
// rather than runtime config: the Skystone deployment is single-tenant
// pointed at odevo.atlassian.net.

const JIRA_BASE_URL = 'https://odevo.atlassian.net';

export function jiraIssueUrl(issueKey: string): string {
  return `${JIRA_BASE_URL}/browse/${encodeURIComponent(issueKey)}`;
}
